import { v4 } from '@lukeed/uuid';
import { getShiftX } from './getShiftX';
import { getSpectrumErrorValue } from './getSpectrumErrorValue';
function isExists(peak, spectrum, error) {
    // check if the Peak is already exists
    for (const { x } of spectrum.peaks?.values || []) {
        if (Math.abs(peak.x - x) < error) {
            return true;
        }
    }
    return false;
}
export function getPeakDelta(peak, shiftTarget, shift) {
    const { originalX = 0, x } = peak;
    if (shiftTarget === 'origin') {
        return {
            originalX: x - shift,
            x,
        };
    }
    else {
        return {
            originalX,
            x: originalX + shift,
        };
    }
}
export function mapPeaks(peaks, spectrum, options = {}) {
    const { checkIsExisting = true, shiftTarget = 'origin' } = options;
    const shiftX = getShiftX(spectrum);
    const error = getSpectrumErrorValue(spectrum);
    const newPeaks = [];
    for (const peak of peaks) {
        const peakDelta = getPeakDelta(peak, shiftTarget, shiftX);
        if (!checkIsExisting ||
            (checkIsExisting && !isExists(peak, spectrum, error))) {
            newPeaks.push({
                ...peak,
                id: peak?.id || v4(),
                ...peakDelta,
            });
        }
    }
    return newPeaks;
}
//# sourceMappingURL=mapPeaks.js.map